import styled from "styled-components";

export const ControllerSearchMemberPointWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
`;

export const ControllerSearchMemberPoint = styled.div`
  flex-direction: column;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  gap: 5px;
  text-align: center;
  padding: 0 15px;

  > .name {
    font-family: Pretendard;
    font-size: 10px;
    font-weight: 500;
    text-align: center;
  }

  > .value {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
  }
`;

export const ControllerReEntryWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background: #fff;
  width: 1168px;
  height: 661px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  padding: 50px;
  box-sizing: border-box;

  > .content-wrapper {
    display: flex;
    justify-content: space-between;
  }
`;

export const ControllerReEntryContentWrapper = styled.div`
  position: relative;

  > .title {
    font-family: Pretendard;
    font-size: 23.61px;
    font-weight: 600;
    margin: 25px 0;
  }
`;

export const ControllerReEntryButton = styled.div<{ on: boolean }>`
  width: 108px;
  height: 34px;
  border-radius: 9.78px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14.67px;
  line-height: 34px;
  text-align: center;
  color: ${(p) => (p.on ? "#fff" : "#121212")};
  background: ${(p) => (p.on ? "#6436E7" : "#f0f0f0")};
  margin-top: 40px;
  cursor: pointer;
`;

export const ControllerReEntryContentHeader = styled.div`
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 600;

  > .member-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ControllerReEntryUserNameWrapper = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 10px;

  > .nickname {
    width: 133px;
    height: 44px;
    gap: 10px;
    border-radius: 9.78px;
    background: #7f25fb;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 500;
  }

  > .more {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    > img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    > .memo {
      position: absolute;
      width: max-content;
      max-width: 250px;
      word-break: break-all;
      height: auto;
      padding: 8px 10px;
      border-radius: 10px;
      background: #ffffff;
      border: 0.93px solid #d9d9d9;
      box-shadow: 0px 3.71px 3.71px 0px #00000040;
      box-sizing: border-box;
      top: 120%;
      left: 0;
      z-index: 100;
      font-family: Pretendard;
      font-weight: 500;
      font-size: 15px;
      min-width: 150px;
      text-align: left;
    }
  }
`;

export const ControllerReEntryListWrapper = styled.div`
  width: 524px;
  height: 496px;
  border-radius: 6.74px;
  background: #f0f0f0;
  padding: 30px 20px 0;
  box-sizing: border-box;

  > .title {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 23.61px;
    line-height: 100%;
    color: #121212;
  }

  > .list-box {
    margin-top: 20px;
    display: flex;
    height: 355px;
    flex-direction: column;
    gap: 5px;
  }
`;

export const ControllerReEntryListItem = styled.div`
  display: flex;
  gap: 10px;
  width: 484px;
  height: 55px;
  padding: 5.87px 25px;
  border-radius: 14.71px;
  background: #fff;
  box-sizing: border-box;
  align-items: center;
  font-family: Pretendard;
  font-size: 14.67px;
  font-weight: 600;
  text-align: center;
  justify-content: space-between;

  &.overlay {
    background: #bebebe;
  }
`;

export const ControllerReEntryListItemInfo = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;

  > .pay {
    display: flex;
    align-items: center;
    gap: 9px;
    position: relative;

    > .more {
      width: 15px;
      height: 15px;
      cursor: pointer;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  > .red {
    width: 55px;
    height: 34px;
    background: #d91818;
    color: #fff;
    border-radius: 9.78px;
    line-height: 34px;
    text-align: center;
    font-weight: 500;
    cursor: pointer;
  }
  > .box {
    width: 55px;
    height: 34px;
  }
`;
